/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Overlay/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Overlay({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/Overlay",
  innerRef,
  videoHidden,
  isPlaced
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Overlay.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 hidden={!videoHidden}
 style={{'--bc-1-Fp325': isPlaced ? "#00FF00" : "#FF0000"}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}